"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
let SqlClient = class SqlClient {
    async testConnection(_args) {}
    migrationInit(_args) {}
    migrationUp(_args) {}
    migrationDown(_args) {}
    selectAll(_tn) {}
    executeSqlFiles() {}
    async createDatabaseIfNotExists(_args) {}
    async createTableIfNotExists(_args) {}
    startTransaction() {}
    commit() {}
    rollback() {}
    hasTable(_tn) {}
    hasDatabase(_databaseName) {}
    async tableCreate(_args) {}
    async tableUpdate(_args) {}
    async columnCreate(_args) {}
    async columnUpdate(_args) {}
    async columnDelete(_args) {}
    async indexCreate(_args) {}
    async indexUpdate(_args) {}
    async indexDelete(_args) {}
    async relationCreate(_args) {}
    async relationUpdate(_args) {}
    async relationDelete(_args) {}
    async databaseList(_args) {}
    async tableList(_args) {}
    async schemaList(_args) {}
    async tableDelete(_args) {}
    async columnList(_args) {}
    async indexList(_args) {}
    async relationList(_args) {}
    async schemaCreate(_args) {}
    async schemaDelete(_args) {}
    async triggerList(_args) {}
    async triggerCreate(_args) {}
    async triggerRead(_args) {}
    async functionList(_args) {}
    async functionRead(_args) {}
    async procedureList(_args) {}
    async procedureRead(_args) {}
    async viewList(_args) {}
    async viewRead(_args) {}
    async sequenceList(_args = {}) {}
    async sequenceCreate(_args = {}) {}
    async sequenceUpdate(_args = {}) {}
    async sequenceDelete(_args = {}) {}
    async tableCreateStatement(_args) {}
    async tableInsertStatement(_args) {}
    async tableUpdateStatement(_args) {}
    async tableDeleteStatement(_args) {}
    async tableTruncateStatement(_args) {}
    async tableSelectStatement(_args) {}
    async totalRecords(_args) {}
    async getDefaultByteaOutputFormat(_args = {}) {}
    constructor(connectionConfig){
        this.connectionConfig = connectionConfig;
        this.sqlClient = null;
    }
};
const _default = SqlClient;
